import { useRef } from "react";
import { Animated } from "react-native";

export function useAnimatedValue(initialValue: number = 0) {
  return useRef(new Animated.Value(initialValue)).current;
}
